import React, { useState, useEffect } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@mui/material/Alert';
import './Popup.scss';
import { showPopup } from '../actions/index'
import { connect } from 'react-redux'

const Popup = (props) => {

    const [open, setOpen] = useState(false)

    useEffect(() => {
        setOpen(props.popup.active)
    }, [props.popup])

    const handleCloseSnackbar = () => {
        props.showPopup({ active: false, message: props.popup.message, type: props.popup.type })
    }

    return (
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            open={open}
            TransitionComponent={Slide}
            autoHideDuration={4000}
            onClose={handleCloseSnackbar}
        >
            <Alert severity={props.popup.type}>{props.popup.message}</Alert>
        </Snackbar>
    )
}

const mapDispatchToProps = {
    showPopup
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(Popup)
